<button
  class="chip p-y-8 base-border-radius p2 fw-medium justify-content-center d-flex align-items-center gap-8 {{ withIcon ? 'p-x-48' : 'p-x-32' }} {{ disabled ? 'c-t-gray-500 c-bg-gray-200' : 'c-t-blue-700 c-bg-blue-200' }} full-width"
  (click)="onClick.emit(value)"
  height="40px"
  type="button"
>

  <div class="position-relative d-flex gap-8 align-items-center">
    @if (selected && withIcon) {
      <i class="ri-check-line icon-sm position-absolute"></i>
    }

    <span class="white-space-nowrap text-overflow-ellipsis overflow-hidden full-width d-block text-center">
      {{ label }}
    </span>

    @if (suffixIcon) {
      <i class="{{ suffixIcon }} {{ suffixIconClass }}"></i>
    }
  </div>
</button>
